export default {
  applies_to_articles: 'Aplica-se aos seguintes itens',
};
